var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block-title flex column gap-10",class:{'small': _vm.small}},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"bottom-line"})])
}
var staticRenderFns = []

export { render, staticRenderFns }